import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createSlots as _createSlots, vShow as _vShow, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = {
  key: 0,
  class: "filter-box"
}
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  key: 0,
  class: "filter-box"
}
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = {
  key: 1,
  class: "filter-box"
}
const _hoisted_9 = {
  key: 2,
  class: "filter-box"
}
const _hoisted_10 = {
  key: 3,
  class: "filter-box"
}
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = {
  key: 0,
  class: "ml-10 filter-mark"
}
const _hoisted_13 = { class: "split-table-layout" }
const _hoisted_14 = { class: "status" }
const _hoisted_15 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_16 = { class: "tab-title_left fl" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = { style: {"padding":"6px 10px"} }
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = { style: {"padding":"6px 10px"} }
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = { class: "dialog-footer" }
const _hoisted_24 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CommandRender = _resolveComponent("CommandRender")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_ContactList = _resolveComponent("ContactList")!
  const _component_EngineerInfoList = _resolveComponent("EngineerInfoList")!
  const _component_MarketFee = _resolveComponent("MarketFee")!
  const _component_OutsourceFee = _resolveComponent("OutsourceFee")!
  const _component_ChargeFee = _resolveComponent("ChargeFee")!
  const _component_LogisticTable = _resolveComponent("LogisticTable")!
  const _component_TraceInfo = _resolveComponent("TraceInfo")!
  const _component_InvoiceNumber = _resolveComponent("InvoiceNumber")!
  const _component_DeliverTable = _resolveComponent("DeliverTable")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_MarkerFeeCom = _resolveComponent("MarkerFeeCom")!
  const _component_QuotationFormCom = _resolveComponent("QuotationFormCom")!
  const _component_OrderFormCom = _resolveComponent("OrderFormCom")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_RegistCharge = _resolveComponent("RegistCharge")!
  const _component_ViewImageLlist = _resolveComponent("ViewImageLlist")!
  const _component_FormDeliverComponent = _resolveComponent("FormDeliverComponent")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilterField, (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: field.fieldKey
                }, [
                  (!field.visible || field.visible({
                pageType: _ctx.pageType,
                type: _ctx.type,
                showStateFilter: _ctx.showStateFilter
              }) )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(field.fieldName), 1),
                        (field.componentType === 'el-input')
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: _ctx.listQuery[field.fieldKey],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.listQuery[field.fieldKey]) = $event),
                              size: _ctx.t('table.btnSize'),
                              class: "filter-item",
                              clearable: "",
                              onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "size", "onKeyup"]))
                          : (field.componentType === 'el-select')
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                filterable: true,
                                modelValue: _ctx.listQuery[field.fieldKey],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.listQuery[field.fieldKey]) = $event),
                                class: "filter-item",
                                placeholder: "",
                                clearable: "",
                                size: _ctx.t('table.btnSize'),
                                onFocus: ($event: any) => (_ctx.handleFilterFocus(field)),
                                onChange: _ctx.handleFilter
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.handleFilterOptions(field).length)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.handleFilterOptions(field), (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.mark,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    : (_openBlock(), _createBlock(_component_el_option, {
                                        key: 1,
                                        value: -1,
                                        disabled: ""
                                      }, {
                                        default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                          _createTextVNode("暂无数据", -1)
                                        ]))]),
                                        _: 1
                                      }))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "size", "onFocus", "onChange"]))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (_ctx.isReceivedPage() || _ctx.isReceivedDonePage())
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[42] || (_cache[42] = _createElementVNode("span", { class: "label" }, "所属公司", -1)),
                    _createVNode(_component_el_select, {
                      filterable: true,
                      modelValue: _ctx.listQuery.titleId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.titleId) = $event)),
                      class: "filter-item",
                      placeholder: "",
                      clearable: "",
                      size: _ctx.t('table.btnSize'),
                      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFilterTitleFocus())),
                      onChange: _ctx.handleFilter
                    }, {
                      default: _withCtx(() => [
                        (_ctx.getTitleCompanyOptions().length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getTitleCompanyOptions(), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: -1,
                              disabled: ""
                            }, {
                              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                _createTextVNode("暂无数据", -1)
                              ]))]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "size", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "label" }, "登记日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              (_ctx.isReceivedDonePage())
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[45] || (_cache[45] = _createElementVNode("span", { class: "label" }, "收款时间", -1)),
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.listQuery.receiveStartDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.receiveStartDate) = $event)),
                      type: "date",
                      placeholder: " ",
                      format: "YYYY-MM-DD",
                      "value-format": "YYYY-MM-DD",
                      onChange: _ctx.handleFilter,
                      size: _ctx.t('table.btnSize')
                    }, null, 8, ["modelValue", "onChange", "size"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isReceivedDonePage())
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[46] || (_cache[46] = _createElementVNode("span", { class: "label" }, "至", -1)),
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.listQuery.receiveEndDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.receiveEndDate) = $event)),
                      type: "date",
                      placeholder: " ",
                      format: "YYYY-MM-DD",
                      "value-format": "YYYY-MM-DD",
                      onChange: _ctx.handleFilter,
                      size: _ctx.t('table.btnSize')
                    }, null, 8, ["modelValue", "onChange", "size"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isBusinessPage())
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.listQuery.receivedStatus,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.receivedStatus) = $event)),
                      onChange: _ctx.handleFilter
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: "0,2" }, {
                          default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                            _createTextVNode("未收款", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: "3" }, {
                          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                            _createTextVNode("已收款", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: "4" }, {
                          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                            _createTextVNode("无需收款", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: "" }, {
                          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                            _createTextVNode("全部", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.search')), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.add')), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCommand('quotation')))
          }, {
            default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
              _createTextVNode(" 报价 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_QUATION` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCommand('order')))
          }, {
            default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
              _createTextVNode(" 创建订单 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ORDER` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.reset')), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[53] || (_cache[53] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[54] || (_cache[54] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          (_ctx.mainPage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [...(_cache[55] || (_cache[55] = [
                _createStaticVNode("<span class=\"status-item\"><span class=\"status-square\" style=\"background-color:red;\"></span><span class=\"status-text\">待报价</span></span><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:blue;\"></span><span class=\"status-text\">待订单</span></span><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:gray;\"></span><span class=\"status-text\">已取消</span></span>", 3)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: el => { if (el) _ctx.tableListRef[0] = el },
            dataList: _ctx.list,
            columnAllData: _ctx.columnAllData,
            tableName: _ctx.TableName,
            permissionName: _ctx.permissionName,
            showSelection: true,
            isShowPagination: false,
            handleDefaultWidth: 140,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            canRefresh: false,
            canChangeColumn: false,
            canCommand: _ctx.canCommand,
            tableRowClassName: _ctx.tableRowClassName,
            showSummary: _ctx.showSummary,
            style: {"height":"100%","overflow":"hidden"},
            onRowClick: _ctx.handleRowClick,
            onCommandChange: _ctx.handleCommand
          }, _createSlots({
            "operation-action": _withCtx((scope) => [
              (_ctx.showDefaultCommand && scope.row.status !== '已取消' && scope.row.changeStatus !== '申请取消')
                ? (_openBlock(), _createBlock(_component_CommandRender, {
                    key: 0,
                    scopeRow: scope.row,
                    codeList: _ctx.btnList,
                    permissionName: _ctx.permissionName,
                    onCommandChange: _ctx.handleCommand
                  }, null, 8, ["scopeRow", "codeList", "permissionName", "onCommandChange"]))
                : (_openBlock(), _createBlock(_component_el_link, {
                    key: 1,
                    href: "javascript:void(0);",
                    class: "mr-10",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleCommand('preview', scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                      _createTextVNode(" 查看大图 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])),
              _renderSlot(_ctx.$slots, "command", _normalizeProps(_guardReactiveProps({ scope })))
            ]),
            _: 2
          }, [
            (_ctx.mainPage)
              ? {
                  name: "no",
                  fn: _withCtx((scope) => [
                    _createElementVNode("span", {
                      class: _normalizeClass([scope.row.changeStatus === '发起修改' ? 'redStatusStyle' : scope.row.changeStatus === '申请取消' ? 'yellowStatusStyle' : '', "statusStyle"])
                    }, [
                      (['发起修改', '申请取消'].includes(scope.row.changeStatus))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[56] || (_cache[56] = _createElementVNode("i", { class: "iconfont icon-tubiao-40" }, null, -1)),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(scope.row.changeStatus), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(scope.row.no), 1)
                    ], 2)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["dataList", "columnAllData", "tableName", "permissionName", "newHpx", "canCommand", "tableRowClassName", "showSummary", "onRowClick", "onCommandChange"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_17))
              }), 128))
            ])
          ]),
          (_ctx.tabList.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.activeTab === 1)
                  ? (_openBlock(), _createBlock(_component_ContactList, {
                      key: 0,
                      ref: "ContactList",
                      id: _ctx.activeId
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 2)
                  ? (_openBlock(), _createBlock(_component_EngineerInfoList, {
                      key: 1,
                      ref: "EngineerInfoList",
                      id: _ctx.activeId
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 4)
                  ? (_openBlock(), _createBlock(_component_MarketFee, {
                      key: 2,
                      ref: "MarketFee",
                      id: _ctx.activeId,
                      marketFeeCanCommand: _ctx.marketFeeCanCommand,
                      businessDetail: _ctx.activeRow
                    }, null, 8, ["id", "marketFeeCanCommand", "businessDetail"]))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 8)
                  ? (_openBlock(), _createBlock(_component_OutsourceFee, {
                      key: 3,
                      ref: "OutsourceFee",
                      id: _ctx.activeId,
                      businessDetail: _ctx.activeRow
                    }, null, 8, ["id", "businessDetail"]))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 5)
                  ? (_openBlock(), _createBlock(_component_ChargeFee, {
                      key: 4,
                      ref: "ChargeFee",
                      id: _ctx.activeId,
                      api: "business"
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 6)
                  ? (_openBlock(), _createBlock(_component_LogisticTable, {
                      key: 5,
                      sendFlag: 0,
                      TableName: "TABLE_DELIVERY_INFO",
                      permissionName: "LOGISTIC_INFO",
                      ref: "LogisticTable",
                      sourceId: _ctx.activeId,
                      sourceType: 1
                    }, null, 8, ["sourceId"]))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 3)
                  ? (_openBlock(), _createBlock(_component_TraceInfo, {
                      key: 6,
                      ref: "TraceInfo",
                      id: _ctx.activeId,
                      api: "business"
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 7)
                  ? (_openBlock(), _createBlock(_component_InvoiceNumber, {
                      key: 7,
                      ref: "InvoiceNumber",
                      id: _ctx.activeId,
                      api: `business/${_ctx.activeId}/actions/invoice`
                    }, null, 8, ["id", "api"]))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 9)
                  ? (_openBlock(), _createBlock(_component_DeliverTable, {
                      key: 8,
                      ref: "DeliverTable",
                      id: _ctx.activeId
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.quotationVisible && !_ctx.orderVisible && !_ctx.marketFeeVisible && !_ctx.materDeliveryVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'business',
          commandState: _ctx.commandState,
          isShowSubmitBtn: _ctx.commandState !== 'view',
          "onUpdate:visibel": _cache[14] || (_cache[14] = () => _ctx.dialogFormVisible = false),
          onSubmit: _ctx.handleSubmit
        }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "commandState", "isShowSubmitBtn", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.marketFeeVisible)
      ? (_openBlock(), _createBlock(_component_MarkerFeeCom, {
          key: 1,
          id: 0,
          initFormData: _ctx.initMarketFeeFieldData,
          fromFieldData: _ctx.marketFeeFieldData,
          dialogFormVisible: _ctx.marketFeeVisible,
          api: `business/${_ctx.activeId}/actions/marketFee`,
          businessDetail: _ctx.activeRow,
          method: "PUT",
          "onUpdate:visibel": _cache[15] || (_cache[15] = ($event: any) => (_ctx.marketFeeVisible = false))
        }, null, 8, ["initFormData", "fromFieldData", "dialogFormVisible", "api", "businessDetail"]))
      : _createCommentVNode("", true),
    (_ctx.quotationVisible)
      ? (_openBlock(), _createBlock(_component_QuotationFormCom, {
          key: 2,
          dialogFormVisible: _ctx.quotationVisible,
          api: 'quotation',
          from: "business",
          selectionBusiness: _ctx.selectionArray,
          selectcCustomerCompanyId: _ctx.selectcCustomerCompanyId,
          "onUpdate:visibel": _cache[16] || (_cache[16] = () => _ctx.quotationVisible = false),
          onSubmit: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleQuotatioSubmit(_ctx.formData)))
        }, null, 8, ["dialogFormVisible", "selectionBusiness", "selectcCustomerCompanyId"]))
      : _createCommentVNode("", true),
    (_ctx.orderVisible)
      ? (_openBlock(), _createBlock(_component_OrderFormCom, {
          key: 3,
          dialogFormVisible: _ctx.orderVisible,
          api: 'order',
          from: "business",
          selectionBusiness: _ctx.selectionArray,
          selectcCustomerCompanyId: _ctx.selectcCustomerCompanyId.toString(),
          "onUpdate:visibel": _cache[18] || (_cache[18] = () => _ctx.orderVisible = false),
          onSubmit: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleQuotatioSubmit(_ctx.formData)))
        }, null, 8, ["dialogFormVisible", "selectionBusiness", "selectcCustomerCompanyId"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.yejiVisible,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.yejiVisible) = $event)),
      title: "设置业绩类型",
      width: "40%",
      "close-on-click-modal": "",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_18, [
          _createVNode(_component_el_button, {
            onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.yejiVisible = false;_ctx.achieveType = ''}),
            type: "danger"
          }, {
            default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSetYeji
          }, {
            default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.achieveType,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.achieveType) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yejiOption, (item) => {
                return (_openBlock(), _createBlock(_component_el_radio, {
                  label: item.id,
                  key: item.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.mark), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.cancelBusinessVisible,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.cancelBusinessVisible) = $event)),
      title: "提示",
      width: "40%",
      "close-on-click-modal": "",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[23] || (_cache[23] = ($event: any) => {_ctx.cancelBusinessVisible = false;_ctx.cancelBusinessList = []})
          }, {
            default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cancelBusinessList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: {"display":"flex","flex-flow":"column"}
          }, [
            _createElementVNode("span", null, "第" + _toDisplayString(index + 1) + "步:", 1),
            _createElementVNode("span", _hoisted_19, _toDisplayString(item), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.submitStepsVisible,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.submitStepsVisible) = $event)),
      title: "提示",
      width: "40%",
      "close-on-click-modal": "",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[25] || (_cache[25] = ($event: any) => {_ctx.submitStepsVisible = false;_ctx.stepsList = []})
          }, {
            default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepsList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: {"display":"flex","flex-flow":"column"}
          }, [
            _createElementVNode("span", null, "第" + _toDisplayString(index + 1) + "步:", 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(item), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.repairBackVisible,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.repairBackVisible) = $event)),
      title: "返修",
      width: "30%",
      "close-on-click-modal": "",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_23, [
          _createVNode(_component_el_button, {
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.repairBackVisible = false)),
            type: "danger"
          }, {
            default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.repairBackVisible = false;_ctx.handleRepairBackSubmit()})
          }, {
            default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            (_ctx.repairBackDialog.type !== '外包维修')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "工程师:"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: true,
                      modelValue: _ctx.repairBackDialog.engineerIds,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.repairBackDialog.engineerIds) = $event)),
                      class: "filter-item",
                      placeholder: "输入关键字搜索",
                      clearable: "",
                      multiple: "",
                      "collapse-tags": "",
                      size: _ctx.t('table.btnSize')
                    }, {
                      default: _withCtx(() => [
                        (_ctx.engineerOption.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.engineerOption, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.mark,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: -1,
                              disabled: ""
                            }, {
                              default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                _createTextVNode("暂无数据", -1)
                              ]))]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "size"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_form_item, { label: "外包公司:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        filterable: true,
                        modelValue: _ctx.repairBackDialog.outsourceCompanyId,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.repairBackDialog.outsourceCompanyId) = $event)),
                        class: "filter-item",
                        placeholder: "输入关键字搜索",
                        clearable: "",
                        size: _ctx.t('table.btnSize'),
                        onChange: _ctx.handleOutsourceCompanyChange
                      }, {
                        default: _withCtx(() => [
                          (_ctx.outsourceCompanyOption.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.outsourceCompanyOption, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.mark,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            : (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                value: -1,
                                disabled: ""
                              }, {
                                default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                                  _createTextVNode("暂无数据", -1)
                                ]))]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "size", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "外包公司联系人:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        filterable: true,
                        modelValue: _ctx.repairBackDialog.outsourceCompanyContactId,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.repairBackDialog.outsourceCompanyContactId) = $event)),
                        class: "filter-item",
                        placeholder: "输入关键字搜索",
                        clearable: "",
                        size: _ctx.t('table.btnSize')
                      }, {
                        default: _withCtx(() => [
                          (_ctx.outsourceCompanyContactOption.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.outsourceCompanyContactOption, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            : (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                value: -1,
                                disabled: ""
                              }, {
                                default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                  _createTextVNode("暂无数据", -1)
                                ]))]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "size"])
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.receivedRecordVisible,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.receivedRecordVisible) = $event)),
      title: "明细",
      width: "40%",
      "close-on-click-modal": "",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_24, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.receivedRecordVisible = false))
          }, {
            default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ChargeFee, {
          id: _ctx.activeId,
          api: "business"
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.chargeVisible)
      ? (_openBlock(), _createBlock(_component_RegistCharge, {
          key: 4,
          visible: _ctx.chargeVisible,
          selectRow: _ctx.selectRow,
          isRefund: true,
          title: "业务退款",
          multiWithCurrency: _ctx.multiWithCurrency,
          "onUpdate:visibel": _cache[35] || (_cache[35] = () => _ctx.chargeVisible = false),
          onSubmit: _cache[36] || (_cache[36] = ($event: any) => (_ctx.getList()))
        }, null, 8, ["visible", "selectRow", "multiWithCurrency"]))
      : _createCommentVNode("", true),
    (_ctx.viewImagesVisible)
      ? (_openBlock(), _createBlock(_component_ViewImageLlist, {
          key: 5,
          images: _ctx.activeRow.appearancePictures,
          visible: _ctx.viewImagesVisible,
          "onUpdate:visible": _cache[37] || (_cache[37] = ($event: any) => (_ctx.viewImagesVisible = false))
        }, null, 8, ["images", "visible"]))
      : _createCommentVNode("", true),
    (_ctx.materDeliveryVisible)
      ? (_openBlock(), _createBlock(_component_FormDeliverComponent, {
          key: 6,
          id: _ctx.activeId,
          type: "BUSINESS",
          handleResolveTempData: _ctx.handleResolveTempData,
          "onUpdate:visibel": _cache[38] || (_cache[38] = () => _ctx.materDeliveryVisible = false),
          onSubmit: _cache[39] || (_cache[39] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "handleResolveTempData"]))
      : _createCommentVNode("", true),
    (!_ctx.dialogFormVisible && !_ctx.quotationVisible && !_ctx.orderVisible && !_ctx.marketFeeVisible && !_ctx.materDeliveryVisible && _ctx.tabList.length)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 7,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}